import { LoadingButton } from '@mui/lab';
import {
  FormHelperText,
  SelectChangeEvent,
  Stack,
  TextField,
} from '@mui/material';
import { FormsErrorDataType } from 'containers/dashboard/Forms/FormListingType';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

type Props = {
  handleDrop: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    name: string
  ) => void;
  thankyouTitle: string;
  thankyouSubtitle: string;
  thankyouDescription: string;
  thankyouImage: string;
  backButtonLink: string;
  backButtonText: string;
  onChangeMode: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeElement: (
    e:
      | React.ChangeEvent<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
      | SelectChangeEvent
  ) => void;
  stateError: FormsErrorDataType;
};

const ThankYouPageSettings: FunctionComponent<Props> = ({
  handleDrop,
  thankyouTitle,
  thankyouSubtitle,
  thankyouDescription,
  backButtonLink,
  backButtonText,
  thankyouImage,
  stateError,
  onChangeElement,
}) => {
  const { t } = useTranslation();

  const { formImageTypeUploading } = useSelector(
    (state: any) => state.formEditor
  );

  return (
    <Stack direction='column' spacing='30px'>
      <TextField
        id='outlined-basic'
        name='backButtonText'
        label={t('back_button_text')}
        variant='outlined'
        type='text'
        value={backButtonText}
        onChange={onChangeElement}
        error={stateError.backButtonText.length ? true : false}
        helperText={stateError.backButtonText}
      />
      <TextField
        id='outlined-basic'
        name='backButtonLink'
        label={t('back_button_link')}
        variant='outlined'
        type='text'
        value={backButtonLink}
        onChange={onChangeElement}
        error={stateError.backButtonLink.length ? true : false}
        helperText={stateError.backButtonLink}
      />
      <TextField
        id='outlined-basic'
        name='thankyouTitle'
        label={t('thank_you_title')}
        variant='outlined'
        type='string'
        value={thankyouTitle}
        onChange={onChangeElement}
        error={stateError.thankyouTitle.length ? true : false}
        helperText={stateError.thankyouTitle}
      />
      <TextField
        id='outlined-basic'
        name='thankyouSubtitle'
        label={t('thank_you_subtitle')}
        variant='outlined'
        type='string'
        value={thankyouSubtitle}
        onChange={onChangeElement}
        error={stateError.thankyouSubtitle.length ? true : false}
        helperText={stateError.thankyouSubtitle}
      />
      <TextField
        id='outlined-basic'
        name='thankyouDescription'
        label={t('thank_you_description')}
        variant='outlined'
        type='string'
        value={thankyouDescription}
        onChange={onChangeElement}
        error={stateError.thankyouDescription.length ? true : false}
        helperText={stateError.thankyouDescription}
      />
      <input
        accept='image/*'
        style={{ display: 'none' }}
        id='thankyouImageInput'
        onChange={e => handleDrop(e, 'thankyouImage')}
        type='file'
      />
      <label htmlFor='thankyouImageInput'>
        <LoadingButton
          variant='outlined'
          component='span'
          loading={
            formImageTypeUploading !== null &&
            formImageTypeUploading === 'thankyouImage'
          }
        >
          {thankyouImage ? t('update') : t('upload')} {t('thank_you_image')}
        </LoadingButton>
        {stateError.thankyouImage.length ? (
          <FormHelperText variant='filled' error={true}>
            {stateError.thankyouImage}
          </FormHelperText>
        ) : (
          ''
        )}
      </label>
      {thankyouImage ? (
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <img
            src={thankyouImage}
            alt='title'
            style={{ maxHeight: '500px', objectFit: 'contain' }}
          />
        </Stack>
      ) : null}
      <Stack direction='row' spacing='10px'>
        {true && (
          <FormHelperText error={true}>{stateError.paymentType}</FormHelperText>
        )}
      </Stack>
    </Stack>
  );
};

export default React.memo(ThankYouPageSettings);
